import { Outlet } from "react-router-dom"
import RouteLogger from "./route-logger"
import RouteLoading from "./route-loading"

const ProtectedRoute = () => {
  return (
    <>
      <RouteLogger />
      <RouteLoading />
      <Outlet />
    </>
  )
}

export default ProtectedRoute
